import { CircularProgress } from "@mui/material";

import HNSColors from "../../../ui library/HNSColors";

export default function LoadingIndicator({ defaultPadding = "py-4" }) {
  return (
    <div className={`flex h-full w-full items-center justify-center ${defaultPadding}`}>
      <CircularProgress style={{ color: HNSColors.secondary[500] }} />
    </div>
  );
}
